export default "__VITE_ASSET__c5a12de2__"